export default {
  deposit: 'deposit',
  secondPart: 'secondpart',
  balance: 'balance',
  customSearchPaymentOne: 'custom_search_payment_one',
  customSearchPaymentTwo: 'custom_search_payment_two',
};
